<template>
	<div class="second">
		<!-- <div class="s-banner">
			<img src="../static/img/temp/1.png" alt="">
		</div> -->
		<div class="second-wrap w1200">
			<!-- <div class="second-head">
				<h2>{{datas.title}}</h2>
				<div class="breadcrumbs">
					<span>首页</span>/<span>{{datas.title}}</span>
				</div>
			</div> -->
			<div class="second-ctn clearfix">
				<div class="second-top">
					<ul class="second-list">
						<li :class="{act:item.columnId==datas.columnId}" v-for="(item,index) in datas.list" :key="index"
							@click="navClick(item.columnId)">{{item.title}}</li>
					</ul>
				</div>
				<div class="second-main">
					<slot />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'mHeader',
	data () {
		return {
			
		}
	},
	
	props:{
		datas:{
			type:Object,
			default:{}
		}
	},
	
	mounted () {
		//监听鼠标滚动事件
		//window.addEventListener('mousewheel', this.handleScroll, true)||window.addEventListener("DOMMouseScroll",this.handleScroll,false)
	},
	
	methods:{
		//点击左侧菜单时间
		navClick(columnId){
			this.$emit('changeNav',columnId)
		}
	}
}
</script>
 
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.second{background:#F5F8FF;}
.s-banner{
	width:100%; height:460px; position:relative; overflow: hidden;
	img{ width:1920px; height: 460px; position:absolute; top:0; left:50%; margin-left:-960px;}
}
.second-wrap{
	margin:0 auto; position:relative; z-index:10; background:#fff;
	.second-head{
		height:80px;display:flex; justify-content: space-between; align-items: center; 
		//background:rgba(0, 0, 0, .19); 
		padding-right:35px; 
		h2{ 
			width:280px; height:80px; background:#1677FF; font-size:26px; color:#fff;
			display:flex; align-items: center; justify-content: center; 
		}
		.breadcrumbs{
			font-size: 16px; color:#fff;
			span{ display:inline-block; margin:0 5px; }
		}
	}
	.second-ctn{
		margin-top:60px; min-height:600px; padding-bottom:60px;
		.second-left{ 
			width: 280px; background: #FFFFFF; margin-right:40px;
			box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.09); border: 1px solid #F0F0F0;
			.second-list{
				li{
					color:#333333; font-size:14px; font-weight: bold; position:relative; cursor: pointer;
					height:64px; line-height:64px; border-bottom:1px solid #EEEEEE; padding-left:40px;
					&::after{
						content:''; display:inline-block; width:12px; height:12px; 
						background:url('../static/img/common/tri-gray2.png') no-repeat right center; background-size:100% 100%;
						position:absolute; right:14px; top:50%; margin-top:-6px;
					}
					&:hover{ color:#325CB3; }
					&.act{
						 color:#325CB3; 
						 &::after{ background-image:url('../static/img/common/tri-blue2.png'); }
					}
				}
			}
		}
		.second-top{
			
			.second-list{
				height:46px; padding-top:10px;  border-bottom:1px solid #D8DADD;  position:relative; margin-bottom:40px;
				padding-left:32px;
				li{
					float:left; padding:0 10px; height:46px; display:inline-flex; align-items: center; justify-content: center;
					font-size:20px; color:#666666; line-height:44px; position:relative; cursor: pointer; margin-right:36px;
					&.act{
						color:#2E75EB; font-weight: bold;
						&::after{
							content:''; width:100%; height:2px; background:#2E75EB;
							position:absolute; left:0; bottom:-1px;
						}
					}
				}
			}
		}
		.second-main{
			flex:1;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/second.vue